import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { GetConsentsTranslationPipe } from '@app/shared/pipes/get-consents-translation.pipe';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CookieModalComponent } from '@app/core/cookie-consent/extended-cookie-consent/cookie-modal/cookie-modal.component';
import { CookieConsentBaseComponent } from '@app/core/cookie-consent/cookie-consent-base.component';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-extended-cookie-consent',
  imports: [
    GetConsentsTranslationPipe,
    TranslatePipe,
  ],
  templateUrl: './extended-cookie-consent.component.html',
})
export class ExtendedCookieConsentComponent extends CookieConsentBaseComponent {
  protected readonly modalService = inject(BsModalService);

  protected openCustomizeModal(): void {
    const modalRef = this.modalService.show(CookieModalComponent, { class: 'cookie-consent-modal' });
    modalRef.content?.saved.pipe(
      first(),
    ).subscribe(({ accepted }) => accepted ? this.acceptCookies() : this.rejectCookies());
  }
}
